<template>
    <div>
        <scale 
        :model_score="surface_score" 
        :model_comment="surface_comment"  
        :section="section" 
        :contents="contents"
        :title="title"></scale>
    </div>
</template>
<script>
import db from '@/components/firebase.init';
import Scale from '@/components/Scale';
export default {
    props:['section'],
    data(){
        return{
            surface_score:[],
            surface_comment:[],
            na: 0,
            title:"Work Surface",
            contents:[
                {
                    question: "Is there adequate space for required task & equipment?",
                    parts: ['General']
                },
                {
                    question: "Does the workstation height fits the task (writing, reading,precise work – 5cm above elbow)?",
                    parts: ['Elbow']
                },
                {
                    question: "Is the workstation height appropriate for typing (elbow height with arms dangling on the sides)?",
                    parts: ['Elbow']
                },
                {
                    question: "Are heavier work tasks just below elbow height?",
                    parts: ['Elbow']

                },
                {
                    question: "Can the employee move easily to complete work tasks without awkward postures or positioning?",
                    parts: ['Back', 'Neck']
                },
                {
                    question: "Is there appropriate leg room under the work surface for knees(>46 cm) and feet (>61cm)?",
                    parts: ['Knee']
                }
            ]
        }
    },
    methods:{
        getTotalScore(){
            let total = 0;
            this.na = 0;
            for(var x = 0; x < this.surface_score.length; x++){
                if(this.surface_score[x] == 'NA'){
                    this.na++;
                }
                else{
                    total += this.surface_score[x]
                }
            }
            
            return total;
        },
        getTotalNa(){
            return this.na;
        },
        invalid(){
            return this.surface_score.length != this.contents.length || this.surface_score.includes(undefined);
        },
        submit(id){
            let score = this.getTotalScore();
            db.collection('forms').doc(id).update(
                {
                    surface_score: this.surface_score,
                    surface_comment: this.surface_comment,
                    surface_total: score
                }
            ).then(data=>{
                
            })
            .catch(e =>{
                alert(e);
            })
        },
        initializeComment(){
            for(var i = 0; i < this.contents.length; i++){
                this.surface_comment[i] = "";
            }
        }
    },  
    components:{
        'scale' : Scale
    },
    mounted(){
        this.initializeComment();
    }
}
</script>

